import { match as n, P as o } from "ts-pattern";
import { z as a } from "./vendor-DWc995QB.mjs";
import { f } from "./fromEmpty-CUaiIlpZ.mjs";
const l = (e, r) => {
  const { data: t } = r, u = `
[Zod Error] - ${e.code}: ${r.defaultError}
input: "${t}"
path: ${e.path}
  `;
  return console.error(u), { message: r.defaultError };
}, m = (e, r) => ({ message: r.defaultError });
function s(e) {
  return e.transform(f);
}
const i = (e) => a.nullable(a.array(e, { errorMap: l })).transform((r) => r ?? []).default([]), b = (e) => a.array(e, { errorMap: l }).nonempty(), p = (e) => n(e).with(
  o.boolean,
  (r) => a.nullable(a.boolean({ errorMap: l })).transform((t) => t ?? r).default(r)
).with(
  o.nullish,
  (r) => a.nullable(a.boolean({ errorMap: l })).transform((t) => t ?? !1).default(!1)
).otherwise(
  (r) => a.nullable(a.boolean(r)).transform((t) => t ?? !1).default(!1)
), d = (e) => a.nullable(
  a.literal(e).default(e)
).transform((r) => r ?? e), c = (e) => n(e).with(
  o.number,
  (r) => a.nullable(a.number({ errorMap: l })).transform((t) => t ?? r).default(r)
).with(
  o.nullish,
  (r) => a.nullable(a.number({ errorMap: l })).transform((t) => t ?? 0).default(0)
).otherwise(
  (r) => a.nullable(a.number(r)).transform((t) => t ?? 0).default(0)
), h = (e) => n(e).with(
  o.string,
  (r) => a.nullable(a.string({ errorMap: l })).transform((t) => t ?? r).default(r)
).with(
  o.nullish,
  (r) => a.nullable(a.string({ errorMap: l })).transform((t) => t ?? "").default("")
).otherwise(
  (r) => a.nullable(a.string(r)).transform((t) => t ?? "").default("")
), M = (e) => s(a.object(e).nullish()), y = {
  ...a,
  array: i,
  boolean: p,
  defaultErrorMap: m,
  literal: d,
  makeOptional: s,
  nonEmptyArray: b,
  number: c,
  optionalObject: M,
  string: h
};
export {
  i as a,
  p as b,
  l as c,
  m as d,
  c as e,
  d as l,
  s as m,
  b as n,
  M as o,
  h as s,
  y as z
};
//# sourceMappingURL=z-C6LVNL2V.mjs.map
